import React from 'react'

import { ItemMissingVideo } from './ItemMissingVideo'
import { ItemsMissingContainer } from './ItemsMissingContainer'

export function ItemsMissingVideoList({ missingVids }) {
  return (
    <>
      {Object.values(missingVids.exercises).length > 0 && (
        <ItemsMissingContainer title='Exercises'>
          {Object.values(missingVids.exercises).map((exMissingVid, exMissingVidIdx) => (
            <ItemMissingVideo
              key={exMissingVidIdx}
              itemMissingVid={exMissingVid}
              itemMissingVidIdx={exMissingVidIdx}
              itemType='exercise'
            />
          ))}
        </ItemsMissingContainer>
      )}
      {Object.values(missingVids.workoutVids).length > 0 && (
        <ItemsMissingContainer title='Full-length videos'>
          {Object.values(missingVids.workoutVids).map((wktVidMissingVid, wktVidMissingVidIdx) => (
            <ItemMissingVideo
              key={wktVidMissingVidIdx}
              itemMissingVid={wktVidMissingVid}
              itemMissingVidIdx={wktVidMissingVidIdx}
              itemType='Video workout'
            />
          ))}
        </ItemsMissingContainer>
      )}
    </>
  )
}
